import Stats from 'stats.js.fps'
import { DEFAULT_FPS } from '../const'

export const stats = new Stats()

export function fps(): number {
  return Math.round(stats.fps) || DEFAULT_FPS
}

export function speedRatio(): number {
  return fps() / DEFAULT_FPS
}
